import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CmisService} from 'src/app/modules/services/cmis/cmis.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {constantePortail} from '../../../../domain/portail/portail-result';
import {
    DialogListAttachFilesComponent
} from '../../../content-layout/pages/acheteur/appel-offre/proc-passa/ouverture-offres/dialog-list-attach-files/dialog-list-attach-files.component';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {ToastService} from '../../../../modules/toast/toast.service';

@Component({
    selector: 'app-cmis-card',
    templateUrl: './cmis-card.component.html',
    styleUrls: ['./cmis-card.component.css']
})
export class CmisCardComponent implements OnInit {

    cardDetailCMIS = constantePortail.cardDetailCMISService;
    @ViewChild('contentContainer', {static: true}) contentContainer: ElementRef;


    public id = null;
    public item: any;


    constructor(
        private activatedRoute: ActivatedRoute,
        private route: ActivatedRoute,
        private cmisService: CmisService,
        public translate: AppTranslateService,
        private dialog: MatDialog,
        private _location: Location,
        private toast: ToastService
    ) {
    }

    ngOnInit(): void {
        this.id = this.route.snapshot.params.id;
        this.initDetailCMIS();
    }

    _getlabel(x): any {
        if (x == 'A') {
            return this.cardDetailCMIS['title'] + ' lois';
        } else if (x == 'B') {
            return this.cardDetailCMIS['title'] + ' décret';
        } else if (x == 'C') {
            return this.cardDetailCMIS['title'] + ' arrêté';
        } else if (x == 'E') {
            return this.cardDetailCMIS['title'] + ' manuel utilisateur';
        } else {
            return 'Autres';
        }
    }


    _getContent = (data) => {
        switch (this.translate.getDefaultLang()) {
            case 'ar':
                return data['cont2'];
            case 'fr':
                return data['cont1'];
            case 'en':
                return data['contEn'];
        }
    };

    initDetailCMIS() {
        this.cmisService.getPtLawBySeqNo(this.id)
            .subscribe({
                next: (response: any) => {

                    if (response.code == '200') {
                        this.item = response.payload;
                        this.contentContainer.nativeElement.innerHTML = this._getContent(this.item);
                    } else {

                        this.toast.error();
                    }
                },
                error: (e) => {
                    console.error('Error in CmisCardComponent/initDetailCMIS, error::', e);
                    this.toast.error();
                }
            });


    }

    openDialogListAttachFiles(data) {
        this.dialog.open(DialogListAttachFilesComponent, {
            disableClose: true,
            width: '90rem',
            direction: this.translate.getDir(),
            data: {
                dialogTitle: 'Pièces jointes',
                cardTitle: 'Liste pièces jointes',
                bidInfos: {
                    ...data.element,
                    code: data.code,
                },
            },
        });
    }

    onPrecedent() {
        this._location.back();
    }

}
